angular.module('workflow.app')

.factory( 'WorkflowStepTemplates', (
  Collection,
  WorkflowStepTemplate,
  Api,
  $filter
  ) ->

  class WorkflowStepTemplates extends Collection

    getRecordClass: ->
      WorkflowStepTemplate

    getApiClass: ->
      Api.WorkflowStepTemplate

    sort: ->
      super( 'order' )

    getNonDeleted: ->
      $filter( 'filter' )( @, { deleted: '!true'} )

    getCount: ->
      @getNonDeleted().length

    isEmpty: ->
      @getCount() == 0

    getFirst: ->
      if @isEmpty() then undefined else @getNonDeleted()[ 0 ]

    getLast: ->
      if @isEmpty() then undefined else @getNonDeleted()[ @getCount() - 1 ]
)
